import React, { useState } from 'react';
import { FiPlus, FiFileText } from 'react-icons/fi';
import HRMSidebar from '../components/HRMSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function ExpenseReports() {
  const [data, setData] = useLocalState('expenses_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });

  const handleAdd = (newData) => setData([{ ...newData, status: 'Draft' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <HRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiFileText className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Expense Reports ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('emp')} className="p-2 border border-black text-left cursor-pointer">Employee</th>
                <th onClick={() => handleSort('date')} className="p-2 border border-black text-left cursor-pointer">Date</th>
                <th className="p-2 border border-black text-left">Description</th>
                <th onClick={() => handleSort('amount')} className="p-2 border border-black text-right cursor-pointer">Amount</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.emp}</td>
                  <td className="p-2 border border-black">{row.date}</td>
                  <td className="p-2 border border-black">{row.desc}</td>
                  <td className="p-2 border border-black text-right font-medium">{row.amount}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-gray-100 px-2 py-0.5 rounded border">{row.status}</span></td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="6" className="p-4 text-center text-gray-500">No expense reports found.</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Expense Report" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'emp', label: 'Employee Name' }, { name: 'date', label: 'Date' },
          { name: 'desc', label: 'Description' }, { name: 'amount', label: 'Amount' }
        ]} />
      </div>
    </div>
  );
}